import ProductImage from 'components/cart/ProductImage';
import css from 'styles/components/account/floatingReturnItemList.scss';

const FloatingReturnItemList = ({ items, step, boxInfo, onNavigateToBoxSelection, onNavigateToReturnInitiate, onCancelReturn, hasEmptyBoxes }) => {
  const makeContinueButton = () => {
    switch (step) {
      case 'SELECT_RETURN_ITEMS':
        return <button type="button" onClick={onNavigateToBoxSelection}>Continue</button>;
      case 'SELECT_BOX':
        return <button type="button" disabled={hasEmptyBoxes()} onClick={onNavigateToReturnInitiate}>Continue</button>;
    }
  };

  const makeBoxedItems = () => {
    switch (step) {
      case 'SELECT_RETURN_ITEMS':
        return (
          items.map(item => (
            <ProductImage key={item.itemUniqueId} className={css.image} item={item.product} />
          ))
        );
      case 'SELECT_BOX':
        return (
          Object.entries(boxInfo).map(([num, { items }]) => (
            items.map(item => (
              <div key={item.itemUniqueId} className={css.item}>
                <ProductImage className={css.image} item={item.product} />
                <span>Box {num}</span>
              </div>
            ))
          ))
        );
    }
  };

  return (
    <div className={css.returning}>
      <h3>Items you are returning ({ items.length })</h3>
      { makeBoxedItems() }
      <div className={css.buttons}>
        { makeContinueButton() }
        <button type="button" onClick={onCancelReturn}>Cancel</button>
      </div>
    </div>
  );
};

export default FloatingReturnItemList;
